<div class="hpanel gs-widget-cardmargin-bottom-5" *ngIf="showUI && viewType=='MIN'">
  <div class="panel-heading gs-widget-headerhbuilt">
    {{ headerTitle }}
  </div>
  <div  *ngIf="loadAPIcall" class="panel-body">
    <app-common-skeleton *ngIf="loadAPIcall"  [countforView]="1" [NameOftheScreen]="'widgets'"></app-common-skeleton>
  </div>
  <div  *ngIf="!loadAPIcall" class="panel-body">

    <!-- Single visitor: wireframe single-row (avatar + name/title + small Invite). -->
    <div class="gs-single-row" *ngIf="visitorsData.length === 1">
      <a class="gs-single-av" *ngIf="visitorsData[0].photo" title="{{ visitorsData[0].firstName }} {{ visitorsData[0].lastName }}" (click)="route(visitorsData[0])">
        <img [src]="url + visitorsData[0].photo">
      </a>
      <div *ngIf="!visitorsData[0].photo" class="gs-single-av" title="{{ visitorsData[0].firstName }} {{ visitorsData[0].lastName }}" [style.background-color]="getColorName(visitorsData[0].firstName, visitorsData[0].lastName)" (click)="route(visitorsData[0])">
        <div class="circle-text" [style.color]="getTextColor(visitorsData[0].firstName, visitorsData[0].lastName)">{{ getInitialName(visitorsData[0].firstName, visitorsData[0].lastName) }}</div>
      </div>
      <div class="gs-single-info">
        <div class="gs-single-name" title="{{ visitorsData[0].firstName }} {{ visitorsData[0].lastName }}">{{ visitorsData[0].firstName }} {{ visitorsData[0].lastName }}</div>
        <div class="gs-single-role" title="{{ visitorsData[0].title }}">{{ visitorsData[0].title }}</div>
      </div>
      <button type="button" class="gs-invite-sm" (click)="inviteFollower(visitorsData[0])">Invite</button>
    </div>

    <!-- Multiple visitors: avatar row + full-width Invite below. -->
    <ng-container *ngIf="visitorsData.length > 1">
    <div class="row">
      <div class="col-lg-12">
        <div class="community-item">
          <a *ngFor="let item of visitorsData; let i = index;">
            <img class="circles" data-placement="top" data-toggle="tooltip"
              title="{{item.firstName}} {{item.lastName}}" *ngIf="item.photo && i<avatarLimit" [src]="url+item.photo"
              (click)="route(item)" >
              <div title="{{item.firstName}} {{item.lastName}}" *ngIf="!item.photo && i<avatarLimit" (click)="route(item)">
                <div class="circles" [style.background-color]="getColorName(item.firstName,item.lastName)">
                  <div class="circle-text "  [style.color]="getTextColor(item.firstName,item.lastName)" style="font-size: var(--gs-wg-initials-size, 18px) !important; font-weight: bold;">{{ getInitialName(item.firstName,item.lastName) }}</div>
                </div>
              </div>
          </a>
          <!-- "+N": visitors beyond the avatars shown (business data.totalCount) -->
          <button type="button" class="gs-inv-more" *ngIf="visitorMore > 0" [title]="visitorMore + ' more'" (click)="modelopen(template)">+{{ visitorMore }}</button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <button type="button" class="gs-invite-full" (click)="modelopen(template)">Invite</button>
      </div>
    </div>
    </ng-container>
  </div>
</div>

<div class="margin-bottom-5" *ngIf="showUI && viewType=='MAX'" infiniteScroll [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="1500" (scrolled)="onScrollDown()">
  <div class="panel-body cardw">
    <div class="row">
      <div class="col-sm-12" *ngIf="visitorsData.length===0">
        <div class="gs-empty">
          <span class="gs-empty-icon"><ng-icon name="tablerEye"></ng-icon></span>
          <div class="gs-empty-title">No new visitors</div>
        </div>
      </div>
      <div class="col-3">
        <div class="col-md-3 padding-left-0 padding-right-5" *ngFor="let item of visitorsData ">
          <div class="hpanel gs-widget-card contact-panel" style="height: fit-content !important;">
            <div class="panel-body" style="height: 160px !important; padding: 10px;" (click)="userprofile(item.userId)">
              <div class="btn-group  pull-right m-t-m-15">
                <div class="btn-group m-t-20" dropdown>
                  <button type="button" class="btn primary-btn  btn-xs" *ngIf="item.status=='PENDING'"
                    (click)="inviteFollower(item); $event.stopPropagation();">
                    Invite
                  </button>

                  <button type="button" class="btn primary-btn  btn-xs"
                    *ngIf="item.status=='REQUEST_SENT' ||item.status=='REQUEST SEND'"
                    (click)="$event.stopPropagation();">
                    Invite Sent
                  </button>

                </div>
              </div>

              <img *ngIf="item.photo!=null" alt="logo" class="circles" src={{url+item.photo}}
                onerror="this.src='assets/images/userlogoimg.png';">
              <img *ngIf="item.photo==null" alt="logo" class="circles" src="assets/images/userlogoimg.png">

              <div class="row">
                <div class="col-sm-6" style="padding-right: 0px;">
                  <h3 class="ellipse font-bold-14" style="padding-bottom: 1px;"><a (click)="userprofile(item.userId)"
                      data-toggle="tooltip" data-placement="top" title="{{item.firstName}} {{item.lastName}}">
                      {{item.firstName }} {{item.lastName }}</a></h3>
                </div>
              </div>

              <div class="text-muted font-bold m-b-xs ellipse" data-toggle="tooltip" data-placement="top"
                title="{{item.title}}">
                {{item.title }}</div>
              <p class="ellipse" data-toggle="tooltip" data-placement="top" title="{{item.organisation}}">
                {{item.organisation }}
              </p>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</div>



<ng-template #template>

   <div class="common-header-flex">
      <div>Invite visitors</div>
      <button><span class="common-close" (click)="closeModal()">&times;</span></button>
    </div>
    <!-- Search + Select All on a single row: search grows to fill, Select All
         pinned to the flex end. `.invite-search-wrap` keeps position:relative
         so the `.pos-rel-28` magnifier stays anchored to the input. -->
    <div class="col-sm-12 invite-action-row">
      <div class="invite-search-wrap">
        <input type="text" class="form-control pd-lt-30" (keyup)="onSearch($event)" name="searchName" id=""
          aria-describedby="helpId" placeholder="Search Visitors" [(ngModel)]="searchName" />
        <ng-icon name="tablerSearch" class="pos-rel-28" style="left: 11px !important;"></ng-icon>
      </div>
      <div class="invite-select-all" *ngIf="(visitorsData | filter: searchName).length > 1">
        <!-- && !beingTyped -->
        <label for="">Select All</label>
        <div class="custom-checkbox em" style="margin-top: -18px !important;">
          <label class="checkbox-label font-bold" style="text-align: center">
            <input type="checkbox" [(ngModel)]="theChecker" (change)="checkAll($event)" />
            <span class="checkmark"></span>
          </label>
        </div>
      </div>
    </div>
    <div class="panel"id="scrollableDiv" #scrollableDiv infiniteScroll [infiniteScrollDistance]="1"
    [infiniteScrollUpDistance]="2" [scrollWindow]="false"  (scrolled)="infiniteScrollTriggered()">
    <!-- <div class="modal-body"> -->
    <div *ngFor="
      let data of visitorsData
        | filter: searchName
        | paginate: config;
      let i = index
    ">
      <div class="oi">
        <div class="row poi">
          <div class="col-sm-1">

            <img *ngIf="data?.photo" class="sddx" [src]="url+data.photo"/>
            <div *ngIf="!data?.photo">
              <div class="circles" [style.background-color]="getColorName(data.firstName,data.lastName)">
                <div class="circle-text " [style.color]="getTextColor(data.firstName,data.lastName)" style="font-weight: bold;font-size: 17px;">{{ getInitialName(data.firstName,data.lastName) }}</div>
              </div>
            </div>
          </div>

          <div class="col-sm-8 lr-lt-10">
            <h6 class="fw-bold" title="{{ data.firstName }} {{ data.lastName }} ">
              {{ data.firstName }} {{ data.lastName }}
            </h6>
            <div class="overflow-hiden-" title="{{ data.title }}">
              {{ data.title }}
            </div>
          </div>
          <div class="col-sm-2 rm">
            <div class="custom-checkbox em">
              <label class="checkbox-label font-bold" style="text-align: center">
                <input type="checkbox" value="{{ data.userId }}" [(ngModel)]="data.checked"
                  (change)="onCheckboxChange(data, $event)" />
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Search returned no matches: mirror the team-members / community-members
         "no results" empty state (screen="SEARCH") instead of a blank panel.
         Only shown when a search term is present and there IS underlying visitor
         data, so the truly-empty list keeps its own handling below. -->
    <div class="col-sm-12"
      *ngIf="(visitorsData | filter: searchName).length === 0 && searchName?.length > 0 && visitorsData?.length > 0">
      <app-nodata-found
        screen="SEARCH"
        [title]="['No results found']"
        [buttonShow]="false">
      </app-nodata-found>
    </div>
    <div>
      <div class="gs-end-of-list" *ngIf="stopScroll" style="margin-top: 1rem;text-align: center;">
        <div class="col-md-12 mg-bt-9">
                    <ng-icon name="tablerCircleCheck"></ng-icon>
                    <!-- <ng-icon name="tablerCircleCheck"></ng-icon> -->
        </div>
        <div class="col-md-12">
          <p class="biase">You've reached the bottom of the page</p>
        </div>
      </div>
     </div>


  </div>


    <!-- </div> -->
    <div class="modal-footer">
      <div class="col-sm-6">
        <!-- <pagination-controls class="left-page-align" (click)="pagecount(page)" (pageChange)="page = $event">
        </pagination-controls> -->
      </div>
      <div class="col-sm-6">
        <div class="footerContainer" style="float: right">
          <div class="footerIteam1">
            <button class="btn btn-default mr-2 w70" (click)="dismiss()">
              Cancel
            </button>
          </div>
          <div class="footerIteam2">
            <button class="btn primary-btn btn-close-gap" [disabled]="selectedEntities.length === 0||apicalled"
              (click)="inviteAll()">
              Send Invitation
            </button>
          </div>
        </div>
      </div>

    </div>
 </ng-template>
